import { endpoint } from "./endpoint";
const Axios = require("axios");

export async function getMutationMap(variant) {
  return process.env.NODE_ENV === "production"
    ? Axios.get(endpoint.concat(`map_${variant}.json`), {
      // query URL without using browser cache 20241129
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
    })
      .then((result) => {
        return result.data;
      })
      .catch((err) => {
        console.log("err :>> ", err);
        return [];
      })
    : new Promise((res, rej) => {
      const mapData = require(`../assets/data/map_${variant}.json`);
      return res(mapData);
    });
}
